import { create } from "zustand";

export const useNotification = create((set) => ({
	data: [],
	addNotification: (payload) => {

		set((state) => ({
			data: [...state.data, payload],
		}));

	},
	removeNotification: (payload) => {

		set((state) => {

			const newState = state.data.filter((data) => data.id !== payload);
			return {
				data: newState,
			};

		});

	},
}));
